import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { dashboardPathForRole } from "../lib/roleRoutes";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/entrar", { replace: true }); return; }
    const sid = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id: sid });
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Bem-vindo(a), ${data.user.name}`);
        // Force reload so AuthContext re-fetches /auth/me via the new cookie
        // Redireciona cada papel pro seu painel (não pra home).
        window.location.href = dashboardPathForRole(data.user.role);
      } catch (e) {
        toast.error("Não foi possível concluir o login com Google");
        nav("/entrar", { replace: true });
      }
    })();
  }, [location, nav]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-slate-500 gap-2">
      <Loader2 className="w-5 h-5 animate-spin" /> Finalizando login…
    </div>
  );
};

export default AuthCallback;
